import { CtaColumnData } from "@/types/pages/blocks"
import { Link } from "react-router-dom"
import { resolveNavLink } from "@/utils/navigation"

export default function CtaColumn(props: CtaColumnData) {
  const { title, description, button } = props
  const resolvedLink = button ? resolveNavLink(button) : { url: '#', isExternal: false }

  return (
    <div className="relative w-full min-h-[360px] flex flex-col items-center justify-center text-center group rounded-lg overflow-hidden bg-primary px-6 py-12">
      <div className="flex flex-col gap-4 md:gap-6 items-center max-w-2xl">
        {title && (
          <h2 
            className="text-3xl md:text-4xl font-bold text-white text-shadow-sm" 
            dangerouslySetInnerHTML={{ __html: title }} 
          />
        )}
        
        {description && (
          <div 
            className="text-lg text-on-primary prose prose-invert max-w-none prose-p:my-1" 
            dangerouslySetInnerHTML={{ __html: description }} 
          />
        )}
        
        {button && button.label && (
          <Link
            to={resolvedLink.url}
            target={resolvedLink.isExternal ? '_blank' : '_self'}
            rel={resolvedLink.isExternal ? 'noopener noreferrer' : undefined}
            className="inline-block mt-2 px-8 py-3 bg-white text-primary-text rounded-md shadow-sm font-semibold hover:bg-gray-100 transition-colors"
          >
            {button.label}
          </Link>
        )}
      </div>
    </div>
  )
}
